module.exports = __webpack_public_path__ + "img/loupe.acbf0e10.svg";